const Shimmer = () => {
    return <div>
        <div className="shimmer-wrapper">
            <div className="shimmer-text"></div>
            <div className="shimmer-row">
                {Array.from({length: 10}).map((_, index) => (
                    <div key={index} className="shimmer-box-1"></div>
                ))}
            </div>
        </div>

        <div className="shimmer-wrapper">
            <div className="shimmer-text"></div>
            <div className="shimmer-row">
                {Array.from({length: 10}).map((_, index) => (
                    <div key={index} className="shimmer-box-1"></div>
                ))}
            </div>
        </div>

        <div className="shimmer-wrapper">
            <div className="shimmer-text"></div>
            <div className="shimmer-row">
                {Array.from({length: 10}).map((_, index) => (
                    <div key={index} className="shimmer-box-1"></div>
                ))}
            </div>
        </div>

        <div className="shimmer-wrapper">
            <div className="shimmer-text"></div>
            <div className="shimmer-row">
                {Array.from({length: 10}).map((_, index) => (
                    <div key={index} className="shimmer-box-1"></div>
                ))}
            </div>
        </div>
    </div>
}

export default Shimmer;
